import { Box } from 'theme-ui'

import Footer from 'src/components/navigation/footer/Footer'

import type { WithChildren } from 'src/types/utils'

const Default = ({
  children,
  withNewsletter = false
}: WithChildren & { withNewsletter?: boolean }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {children}
      <Footer withNewsletter={withNewsletter} />
    </Box>
  )
}

export default Default
